import { TableCell as MTableCell } from '@project44/manifest-ds';

const styles = {
  base: {
    bgColor: '$background-primary',
    padding: '$medium',
    height: '72px',
    '&:first-of-type': {
      boxShadow: 'inset -1px 0 0 0 #E4E6E7', // $border-primary
      left: 0,
      position: 'sticky',
      zIndex: 1,
    },
    '&:nth-child(2)': {
      padding: '$medium $medium $medium $large',
    },
  },
};

interface ITableCell {
  children: React.ReactNode;
}

function TableCell({ children }: ITableCell) {
  return <MTableCell css={styles.base}>{children}</MTableCell>;
}

export default TableCell;
